import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext"; // Assumes you have the AuthContext set up

const ProtectedRoute2 = ({ children }) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated  ? <Navigate to="/dashboard" /> :children ;
};

export default ProtectedRoute2;
